export default {
    WarehouseManagement: {
        Header: {
            name: '仓库名称',
            code: '仓库编码',
            status: '逻辑仓状态',
            Add: '新增仓库',
        },
        Main: {
            name: '联系人名称',
            phone: '联系人手机',
            address: '仓库地址',
            warehouse: '逻辑仓名称',
            by: '创建人',
            time: '创建时间',
            Operation: '操作',
            ps: '是否删除 ?',
            ps1: '逻辑仓操作，是否继续 ?',
        },
        form: {
            Basic: '基本信息',
            name: '仓库名称',
            code: '仓库编码',
            Contact: '联系人姓名',
            phone: '联系人手机',
            address: '仓库地址',
            Detailed: '详细地址',
            Description: '描述',
            Bin: '逻辑仓',
            warehouse: '逻辑仓名称',
            Please: '请选择国家/州',
            enter: '请输入详细地址',
            a: '请输入仓库编码',
            arehouse: '请输入仓库名称',
            ontact: '请输入联系人姓名',
            logical: '请输入逻辑仓名称',
            detail: '请输入详细地址',
            Edit: '编辑仓库',
            Create: '新建仓库',
            Saved: '保存成功',
            postcodeText: '请输入邮编',
            country: '国家',
            state: '州',
            city: '郊区',
            districtName: '区',
            postcode: '邮编',
            isLogisticsSpecified: '是否指定物流',
            isPickUp: '是否自提单',
            chooseLogistics: '物流信息',
            DefaultMargin: '利润率',
            byPostCode: '根据邮编自动补充区、州、国',
            msgErrorText: '导入的必填信息不完整，请填写后重新导入',
            if: '包裹尺寸',
            need: '托盘数量',
            time: '预计取货时间',

            status0: '未报价',
            status1: '待确认',
            status2: '已确认',
            status3: '已拒绝',
            Label: '修改面单',
            isQuotation: '审核报价',
            Quote: '输入报价',
            Dimension: '测量尺寸',
            Shipping: '修改邮寄方式',
            Length: '包裹长度',
            Width: '包裹宽度',
            Height: '包裹高度',
            Weight: '包裹重量',
            quotationStatus: '报价状态',
            Quotation: '是否需要报价',
            check: '是否需要尺寸',
            filled: '尺寸是否填写',
            amount: '报价金额',
            Quotenot: '价格未确认',
            not: '尺寸未填写',
            refuse: '拒绝',
            agree: '同意',
            change: '如果您拒绝报价，请您修改运输方式为Customer Manual Booking',
        }
    },
};
